import { render, staticRenderFns } from "./FacilitiesButtons.vue?vue&type=template&id=0c0434cd&"
import script from "./FacilitiesButtons.vue?vue&type=script&lang=js&"
export * from "./FacilitiesButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0434cd')) {
      api.createRecord('0c0434cd', component.options)
    } else {
      api.reload('0c0434cd', component.options)
    }
    module.hot.accept("./FacilitiesButtons.vue?vue&type=template&id=0c0434cd&", function () {
      api.rerender('0c0434cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/FacilitiesButtons.vue"
export default component.exports